<template lang="pug">
BaseListEstimatedData(
  :plan="plan"
  :listAction="currentConfig.listAction"
  :exportAction="currentConfig.exportAction"
  :importAction="currentConfig.importAction"
  :saveAction="currentConfig.saveAction"
  :editColumns="currentConfig.editColumns"
  :costNames="costNames"
  :title="currentConfig.title"
  :tableField="currentConfig.tableField"
)
</template>

<script>
import BaseListEstimatedData from './estimated_data/BaseListEstimatedData.vue'
import { mapActions } from 'vuex'

export default {
  props: {
    plan: {
      type: Object,
      required: true
    }
  },
  components: {
    BaseListEstimatedData
  },
  data () {
    const listDataConfig = {
      'COSTOS': {
        listAction: this.listEstimatedCost,
        exportAction: this.exportEstimatedCost,
        importAction: this.importEstimatedCost,
        saveAction: this.saveEstimatedCost,
        title: 'Costos Planificados',
        editColumns: [
          { key: 'date', label: 'Fecha', type: 'date' },
          { key: 'cost_name', label: 'Nombre del costo', type: 'cost' },
          { key: 'estimation', label: 'Costo Estimado', type: 'number' }
        ],
        tableField: [
          {
            text: 'Fecha',
            field: 'date'
          },
          {
            text: 'Costo',
            field: 'cost_name'
          },
          {
            text: 'Costo Planificado',
            field: 'estimation'
          }
        ]
      },
      'VENTAS': {
        listAction: this.listEstimatedSales,
        exportAction: this.exportEstimatedSales,
        importAction: this.importEstimatedSales,
        saveAction: this.saveEstimatedSales,
        title: 'Ventas Planificadas',
        editColumns: [
          { key: 'date', label: 'Fecha', type: 'date' },
          { key: 'quantity', label: 'Ventas Estimadas', type: 'number' },
          { key: 'estimation', label: 'Monto Estimado', type: 'number' }
        ],
        tableField: [
          {
            text: 'Fecha',
            field: 'date'
          },
          {
            text: 'Ventas Estimadas',
            field: 'quantity'
          },
          {
            text: 'Monto Estimado',
            field: 'estimation'
          }
        ]
      },
      'PRODUCCIÓN': {
        listAction: this.listEstimatedProduction,
        exportAction: this.exportEstimatedProduction,
        importAction: this.importEstimatedProduction,
        saveAction: this.saveEstimatedProduction,
        title: 'Producción Planificada',
        editColumns: [
          { key: 'date', label: 'Fecha', type: 'date' },
          { key: 'estimation', label: 'Producción Estimada', type: 'number' }
        ],
        tableField: [
          {
            text: 'Fecha',
            field: 'date'
          },
          {
            text: 'Producción Estimada',
            field: 'estimation'
          }
        ]
      }
    }

    return {
      currentConfig: listDataConfig[this.plan.plan_type]
    }
  },
  computed: {
    costNames () {
      if (this.plan.plan_type !== 'COSTOS' || !this.plan.cost_items) return []
      return this.plan.cost_items.map(e => e.name)
    }
  },
  methods: {
    ...mapActions('estimated_data', [
      'listEstimatedCost', 'listEstimatedSales', 'listEstimatedProduction',
      'exportEstimatedProduction', 'exportEstimatedSales', 'exportEstimatedCost',
      'importEstimatedSales', 'importEstimatedProduction', 'importEstimatedCost',
      'saveEstimatedSales', 'saveEstimatedProduction', 'saveEstimatedCost'
    ])
  }
}
</script>
